var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef } from 'react';
import styles from './infoDialog.module.css';
import { IconButton } from '../../buttons/iconButton/IconButton';
import { Button } from '../../buttons/button/Button';
import { Icons, IconSizes } from '../../icons/icons';
export var InfoDialog = forwardRef(function (_a, ref) {
    var _b = _a.title, title = _b === void 0 ? '' : _b, _c = _a.content, content = _c === void 0 ? '' : _c, _d = _a.buttonText, buttonText = _d === void 0 ? 'Sluiten' : _d, _e = _a.buttonType, buttonType = _e === void 0 ? 'outline' : _e, onClose = _a.onClose;
    return (_jsxs("dialog", __assign({ className: styles.dialog, ref: ref }, { children: [_jsx("p", __assign({ className: styles.title }, { children: title })), _jsx("p", __assign({ className: styles.content }, { children: content })), _jsxs("form", __assign({ method: "dialog" }, { children: [_jsx("div", __assign({ className: styles.close }, { children: _jsx(IconButton, { icon: Icons.CROSS, type: 'clear', size: IconSizes.XXS, onClick: onClose }) })), _jsx(Button, { label: buttonText, full: true, type: buttonType, onClick: onClose })] }))] })));
});
export default InfoDialog;
